"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.A2SClient = void 0;
const aws_amplify_1 = require("aws-amplify");
const Environments_1 = require("./Environments");
const base_query_1 = require("./graphql/assessments/base_query");
const customer_account_1 = require("./graphql/assessments/customer_account");
const permissions_1 = require("./graphql/assessments/permissions");
const snapshots_1 = require("./graphql/assessments/snapshots");
const template_1 = require("./graphql/assessments/template");
const mutations_1 = require("./graphql/generated/mutations");
const queries_1 = require("./graphql/generated/queries");
const mutations_2 = require("./graphql/mutations");
const queries_2 = require("./graphql/queries");
class A2SClient {
    constructor(props) {
        if (A2SClient.initialized) {
            throw new Error('A2SClient should be a singleton (Amplify configuration is global)');
        }
        A2SClient.initialized = true;
        this.env = Environments_1.Environments.getEnvironment(props.domain, props.region);
        // Configure Congito authentication & GraphQL
        aws_amplify_1.Amplify.configure({
            aws_project_region: props.region,
            aws_user_pools_id: this.env.userPoolId,
            aws_user_pools_web_client_id: props.webClientId,
            API: {
                graphql_endpoint: this.env.endpoint,
                graphql_region: props.region,
                graphql_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
                graphql_headers: () => __awaiter(this, void 0, void 0, function* () {
                    return ({
                        Authorization: props.getJwtToken ? yield props.getJwtToken() : yield (yield aws_amplify_1.Auth.currentSession()).getIdToken().getJwtToken()
                    });
                }),
            }
        });
    }
    // Queries
    getAssessments(filter, includeSubQueries = {}, limit = null, nextToken = null) {
        return this.call(this.generateAssessmentQuery(includeSubQueries), { filter, limit, nextToken });
    }
    getAssessmentTemplates(filter, limit = null, nextToken = null) {
        return this.call(queries_1.getAssessmentTemplates, { filter, limit, nextToken });
    }
    listAssessmentTemplates(limit = null, nextToken = null) {
        return this.call(queries_2.listAssessmentTemplates, { filter: null, limit, nextToken });
    }
    getCustomerAccount(filter, includeSubQueries = {}, limit = null, nextToken = null) {
        return this.call((includeSubQueries === null || includeSubQueries === void 0 ? void 0 : includeSubQueries.assessmentsInfo) ? queries_1.getCustomerAccounts : queries_2.getCustomerAccountsBase, { filter, limit, nextToken });
    }
    getAssessmentFeatures(limit = null, nextToken = null) {
        return this.call(queries_1.getAssessmentFeatures, { limit, nextToken });
    }
    getOrgAssessmentSummary(limit = null, nextToken = null) {
        return this.call(queries_1.getOrgAssessmentSummary, { limit, nextToken });
    }
    getCustomizedPrescribedActions(filter, nextToken = null) {
        return this.call(queries_1.getCustomizedPrescribedActions, { filter, nextToken });
    }
    // Mutations
    createCustomerAccount(input) {
        return this.call(mutations_1.createCustomerAccount, { input });
    }
    updateCustomerAccount(id, input) {
        return this.call(mutations_1.updateCustomerAccount, { id, input });
    }
    createAssessment(input) {
        return this.call(mutations_2.createAssessmentBase, { input });
    }
    updateAssessment(id, input) {
        return this.call(mutations_2.updateAssessmentBase, { id, input });
    }
    deleteAssessment(id) {
        return this.call(mutations_1.deleteAssessment, { id });
    }
    createAssessmentSnapshot(input) {
        return this.call(mutations_2.createAssessmentSnapshotBase, { input });
    }
    createAssessmentPermission(input) {
        return this.call(mutations_1.createAssessmentPermission, { input });
    }
    deleteAssessmentPermission(input) {
        return this.call(mutations_1.deleteAssessmentPermission, { input });
    }
    acceptAssessmentInvitation(invitationId) {
        return this.call(mutations_1.acceptAssessmentInvitation, { invitationId });
    }
    deleteAssessmentPermissionInvitation(invitationId) {
        return this.call(mutations_1.deleteAssessmentPermissionInvitation, { invitationId });
    }
    createOrUpdateAssessmentResponses(input) {
        return this.call(mutations_1.createOrUpdateAssessmentResponses, { input });
    }
    deleteAssessmentResponses(input) {
        return this.call(mutations_1.deleteAssessmentResponses, { input });
    }
    deleteAllAssessmentResponses(assessmentIds) {
        return this.call(mutations_1.deleteAllAssessmentResponses, { assessmentIds });
    }
    createOrUpdateAssessmentObservationsActions(input) {
        return this.call(mutations_1.createOrUpdateAssessmentObservationsActions, { input });
    }
    deleteAssessmentObservationsActions(input) {
        return this.call(mutations_1.deleteAssessmentObservationsActions, { input });
    }
    deleteAllAssessmentObservationsActions(assessmentIds) {
        return this.call(mutations_1.deleteAllAssessmentObservationsActions, { assessmentIds });
    }
    createOrUpdateCustomizedPrescribedActions(input) {
        return this.call(mutations_1.createOrUpdateCustomizedPrescribedActions, { input });
    }
    deleteCustomizedPrescribedActions(input) {
        return this.call(mutations_1.deleteCustomizedPrescribedActions, { input });
    }
    deleteAllCustomizedPrescribedActions(input) {
        return this.call(mutations_1.deleteAllCustomizedPrescribedActions, { input });
    }
    call(gql, headers) {
        return aws_amplify_1.API.graphql((0, aws_amplify_1.graphqlOperation)(gql, headers));
    }
    generateAssessmentQuery(includeSubQueries) {
        const extraQueries = [];
        if (includeSubQueries === null || includeSubQueries === void 0 ? void 0 : includeSubQueries.customerAccount) {
            extraQueries.push(customer_account_1.customerAccountQuery);
        }
        if (includeSubQueries === null || includeSubQueries === void 0 ? void 0 : includeSubQueries.permissions) {
            extraQueries.push(permissions_1.permissionsQuery);
        }
        if (includeSubQueries === null || includeSubQueries === void 0 ? void 0 : includeSubQueries.template) {
            extraQueries.push(template_1.templateQuery);
        }
        if (includeSubQueries.snapshots !== undefined && includeSubQueries.snapshots === queries_2.SnapshotsSubQuery.METADATA_ONLY) {
            const query = (includeSubQueries.snapshotsPage ?
                (0, snapshots_1.dynamicSnapshotConnectionMetadataQuery)(includeSubQueries.snapshotsPage) :
                (0, snapshots_1.dynamicSnapshotConnectionMetadataQuery)(0));
            extraQueries.push(query);
        }
        else if (includeSubQueries.snapshots !== undefined && includeSubQueries.snapshots === queries_2.SnapshotsSubQuery.METADATA_AND_CONTENT) {
            const query = (includeSubQueries.snapshotsPage ?
                (0, snapshots_1.dynamicSnapshotConnectionQuery)(includeSubQueries.snapshotsPage) :
                (0, snapshots_1.dynamicSnapshotConnectionQuery)(0));
            extraQueries.push(query);
        }
        return base_query_1.baseQuery.replace('##SUB_QUERIES##', extraQueries.join(`\n`));
    }
}
exports.A2SClient = A2SClient;
A2SClient.initialized = false;
